export const GET_DEFAULT_NAVIGATION = 'getDefaultNavigation'
export const INCREMENT_NAVIGATION = 'incrementNavigation'
export const INCREMENT_SEARCH = 'incrementSearch'
export const RECOVERY = 'recovery'
